/**
 * @generated SignedSource<<d81ee758572bee431b653186c4675a26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationKind = "other" | "timesheetApproved" | "timesheetEntry" | "timesheetRejected" | "timesheetReview";
export type NotificationStatus = "acknowledged" | "unread";
export type NotificationsMarkAsUnreadMutation$variables = {
  notificationID: string;
};
export type NotificationsMarkAsUnreadMutation$data = {
  readonly notification: {
    readonly acknowledgedAt: string | null;
    readonly actionUrl: string;
    readonly createdAt: string | null;
    readonly id: string;
    readonly kind: NotificationKind;
    readonly status: NotificationStatus;
    readonly subject: string;
    readonly text: string;
  };
};
export type NotificationsMarkAsUnreadMutation = {
  response: NotificationsMarkAsUnreadMutation$data;
  variables: NotificationsMarkAsUnreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationID"
  }
],
v1 = [
  {
    "alias": "notification",
    "args": [
      {
        "kind": "Variable",
        "name": "notificationID",
        "variableName": "notificationID"
      }
    ],
    "concreteType": "Notification",
    "kind": "LinkedField",
    "name": "markNotificationAsUnread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subject",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "acknowledgedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actionUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsMarkAsUnreadMutation",
    "selections": (v1/*: any*/),
    "type": "GeneralMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsMarkAsUnreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "489fafc3254247b54bc96aeae4eda364",
    "id": null,
    "metadata": {},
    "name": "NotificationsMarkAsUnreadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsMarkAsUnreadMutation(\n  $notificationID: ID!\n) {\n  notification: markNotificationAsUnread(notificationID: $notificationID) {\n    id\n    subject\n    status\n    text\n    acknowledgedAt\n    createdAt\n    actionUrl\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e17539a1805b6a365931e3f7e444b21";

export default node;
